import React from 'react';
import API from "../../Services/API";
import {toast} from "react-toastify";
import Header from "../../Layouts/Header";
import Loading from "../../Layouts/Loading";

import InvitePic from "../../Assets/Images/invite.jpg";
import {MdAddLocation, MdDelete, MdEditLocationAlt} from "react-icons/md";
import Toast from "../../Components/Toast";
import {TbArrowBadgeLeft} from "react-icons/tb";
import {useNavigate} from "react-router-dom";

const currencyFormat = Intl.NumberFormat('en-US');

const ManageAddresses = () => {
    const navigate = useNavigate();

    const [isLoaded, setIsLoaded] = React.useState(false);
    const [addresses, setAddresses] = React.useState([]);


    React.useEffect(() => {
        const match = document.cookie.match(new RegExp('(^| )auth=([^;]+)'));
        const token = match ? match[2] : null;
        if(!token) {
            window.location.replace('/login')
        }
        else {

            const params = {
                count: 15,
                page: 1,
                list: 1
            }

            API.getAddresses(params)
                .then((response) => {
                    setAddresses(response.data);
                    setIsLoaded(true);
                })
                .catch((error) => {
                    setIsLoaded(true);
                    if (error.response) {
                        toast.error(error.response.data.message);
                    } else {
                        toast.error(error.message);
                    }
                });
        }
    }, []);

    const deleteAddress = (id) => {
        setIsLoaded(false);
        API.deleteAddress(id)
            .then((response) => {
                const params = {
                    count: 15,
                    page: 1,
                    list: 1
                }
                API.getAddresses(params)
                    .then((response) => {
                        setIsLoaded(true);
                        setAddresses(response.data);

                    })
                    .catch((error) => {
                        setIsLoaded(true);
                        if (error.response) {
                            toast.error(error.response.data.message);
                        } else {
                            toast.error(error.message);
                        }
                    });

            })
            .catch((error) => {
                setIsLoaded(true);
                if (error.response) {
                    toast.error(error.response.data.message);
                } else {
                    toast.error(error.message);
                }
            });
    }

    return (
        <React.Fragment>
            <Toast/>
            <Header title='  مدیریت آدرس ها ' hasBack={true} />
            {
                !isLoaded && <Loading />
            }

            <main className="container-fluid rtl mt-4 pt-4 ">

                {
                    isLoaded && addresses.map (address => {
                        return (
                            <div className="row score-row m-3 p-3" key={address.id}>
                                <div className="col-12 text-small-1 fw-bold">
                                    {address.title}
                                    &nbsp;

                                    <div className='fw-normal text-end text-small-1  pb-3 text-muted my-2 ltr border-bottom'>
                                        {address.address}
                                    </div>
                                </div>

                                <div className="col-6 text-small-3 pt-2 text-primary fw-bold"
                                     onClick={() => navigate(`/edit-address/${address.id}`)}
                                >

                                    <MdEditLocationAlt className='ms-2' />
                                        ویرایش آدرس


                                </div>
                                <div className="col-6 text-small-3 fw-bold text-start  pt-2 text-danger"
                                onClick={() => {
                                    deleteAddress(address.id)
                                }}
                                >

                                      <MdDelete className='ms-2' />
                                    حذف آدرس
                                </div>
                            </div>
                        )
                    })
                }
                <div className="row">
                    <div className="col-12 p-2 fixed-bottom max-w-lg">
                        <button
                            className="btn btn-success bg-success text-end text-small-1 text-semi-big  w-100 p-2  pe-4 border-0"
                            onClick={() => navigate('/add-address')}
                        >
                            ثبت آدرس جدید
                            <span className="badge  p-2 float-start">

<MdAddLocation className='ms-2'/>
                    </span>
                        </button>
                    </div>
                </div>
            </main>

        </React.Fragment>
    );
};

export default ManageAddresses;